/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
const getChildProducts = function (elements, stringify = true) {
    const childProducts = [];
    [...elements].forEach((item) => {
        const { pid, quantity } = item.dataset;

        childProducts.push({
            pid,
            quantity,
        });
    });

    if(stringify) return childProducts.length ? JSON.stringify(childProducts) : [];

    return childProducts.length ? childProducts : [];
};

export default getChildProducts;
